import { isAccessible } from '@racemap/utilities/functions/trackers';
import type { TableCellProps } from 'react-virtualized';
import { SuccessFailIcon } from 'src/components/BasicComponents/SuccessFailIcon';
import { useCurrentUser } from '../../../../lib/customHooks';
import {
  type ManagedTracker,
  TrackerColumnKeys,
} from '../../../../store/trackers/trackers_reducers';
import { Columns } from '../../../DataTable';

interface CellProps extends TableCellProps {
  cellData?: ManagedTracker['state'];
  rowData: ManagedTracker;
}

export const ServerACKColumn = () => {
  const currentUser = useCurrentUser();

  const cellRenderer = ({ rowData }: CellProps) => {
    if (rowData == null || !isAccessible(rowData, currentUser)) return null;

    return <SuccessFailIcon isSuccess={!!rowData.setting?.serverAckEnabled} />;
  };

  return Columns.sortingColumn({
    dataKey: TrackerColumnKeys.SERVER_ACK,
    label: 'Server ACK',
    cellRenderer,
    minWidth: 110,
    columnData: { hiddenOnDefault: true },
    sortingMethod: (_cA, _cB, rowDataA: ManagedTracker, rowDataB: ManagedTracker) =>
      rowDataA.setting?.serverAckEnabled && !rowDataB.setting?.serverAckEnabled
        ? -1
        : !rowDataA.setting?.serverAckEnabled && rowDataB.setting?.serverAckEnabled
          ? 1
          : 0,
  });
};
